// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__m_UOt","loading":"Spinner_loading__mMLx5"};